import { SB } from '@play-co/replicant';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';
import { getLocaleConfig } from 'src/replicant/creatives/text';

/**
 * Assets for daily bonus messages
 */
export const dailyBonusAssets: Record<string, string> = {
  'dailybonus/ja': 'private/chatbot/dailybonus/dailybonus_ja.png',
  'dailybonus/en': 'private/chatbot/dailybonus/dailybonus_en.png',
};

/**
 * Create daily bonus available message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const dailyBonusMessage = createFlexMessageTemplate(
  SB.object({
    locale: SB.tuple(['en', 'ja']),
  }),
  (args, payload, api) => {
    const altText = getLocaleConfig(args.locale).dailyBonus.altText;
    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'horizontal',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`dailybonus/${args.locale}`),
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1.51:1',
            gravity: 'center',
          },
        ],
        paddingAll: '0px',
        justifyContent: 'center',
      },
    });

    return template;
  },
);
